import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X as CloseIcon } from 'lucide-react';
interface WaitlistModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const WaitlistModal = ({
  isOpen,
  onClose
}: WaitlistModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      // Auto-dismiss after 15 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 15000);
      return () => {
        clearTimeout(timer);
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-147">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-50 flex items-center justify-center" onClick={onClose} data-id="element-148">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-[rgba(17,18,30,0.55)] backdrop-blur-[4px]" data-id="element-149" />
          {/* Modal Card */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: [1, 1.04, 0.94],
        transition: {
          duration: 0.3
        }
      }} transition={{
        duration: 0.3
      }} className="relative w-[480px] bg-white/90 backdrop-blur-sm overflow-hidden px-12 py-10" style={{
        borderRadius: '16px',
        boxShadow: `
                0 24px 48px rgba(0,0,0,0.15),
                0 0 80px rgba(134, 121, 223, 0.2),
                0 0 32px rgba(134, 121, 223, 0.15),
                0 0 1px rgba(134, 121, 223, 0.1)
              `,
        background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.98) 100%)'
      }} onClick={e => e.stopPropagation()} data-id="element-150">
            {/* Gradient Overlay */}
            <div className="absolute inset-0 -z-10" style={{
          background: 'radial-gradient(circle at center, rgba(134,121,223,0.08) 0%, transparent 100%)',
          mixBlendMode: 'multiply'
        }} data-id="element-151" />
            {/* Close Button */}
            <button onClick={onClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close modal" data-id="element-152">
              <CloseIcon size={20} data-id="element-153" />
            </button>
            {/* Content */}
            <div className="text-center" data-id="element-154">
              <h2 className="text-[32px] font-bold text-[#6C5EBE] mb-4 font-inter leading-tight" data-id="element-155">
                ✨ You're on the Early-Access List!
              </h2>
              <p className="text-[18px] text-gray-600" data-id="element-156">
                We're excited to have you onboard! We'll email you as soon as
                the next cohort opens—typically within two weeks.
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};